import type { Permission } from '@cartly/shared';
import { PageHeader, cx } from '@cartly/ui';
import { NavLink, Outlet } from 'react-router';
import { useSession } from '../../app/session';

const TABS: { to: string; label: string; permission?: Permission }[] = [
  { to: 'organization', label: 'Organization', permission: 'organization:read' },
  { to: 'members', label: 'Team', permission: 'members:read' },
  { to: 'roles', label: 'Roles', permission: 'members:read' },
  { to: 'security', label: 'Security' },
  { to: 'ai-provider', label: 'AI provider', permission: 'ai:read' },
  { to: 'webhooks', label: 'Webhooks', permission: 'api_keys:manage' },
  { to: 'privacy', label: 'Privacy', permission: 'privacy:manage' },
  { to: 'audit-log', label: 'Audit log', permission: 'audit:read' },
];

export function SettingsLayout() {
  const { can } = useSession();
  return (
    <>
      <PageHeader
        title="Settings"
        description="Manage your organization, team and account security."
      />
      <nav className="tabs settings-tabs" aria-label="Settings sections">
        {TABS.filter((t) => !t.permission || can(t.permission)).map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            className={({ isActive }) => cx('tabs__tab', isActive && 'tabs__tab--active')}
          >
            {t.label}
          </NavLink>
        ))}
      </nav>
      <Outlet />
    </>
  );
}

export function defaultSettingsTab(can: (p: Permission) => boolean): string {
  return TABS.find((t) => !t.permission || can(t.permission))?.to ?? 'security';
}
